// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__2HYmX","itemTitle":"ClientEmergencyInfo_itemTitle__2rQhs","itemText":"ClientEmergencyInfo_itemText__2VeND"};